"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoCodeResponseBaseToJSON = exports.PromoCodeResponseBaseFromJSONTyped = exports.PromoCodeResponseBaseFromJSON = exports.instanceOfPromoCodeResponseBase = void 0;
var runtime_1 = require("../runtime");
var ValidationErrorCode_1 = require("./ValidationErrorCode");
/**
 * Check if a given object implements the PromoCodeResponseBase interface.
 */
function instanceOfPromoCodeResponseBase(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPromoCodeResponseBase = instanceOfPromoCodeResponseBase;
function PromoCodeResponseBaseFromJSON(json) {
    return PromoCodeResponseBaseFromJSONTyped(json, false);
}
exports.PromoCodeResponseBaseFromJSON = PromoCodeResponseBaseFromJSON;
function PromoCodeResponseBaseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'promoCodeId': !(0, runtime_1.exists)(json, 'promo_code_id') ? undefined : json['promo_code_id'],
        'isValid': !(0, runtime_1.exists)(json, 'is_valid') ? undefined : json['is_valid'],
        'promoCodeAmountMicro': !(0, runtime_1.exists)(json, 'promo_code_amount_micro') ? undefined : json['promo_code_amount_micro'],
        'validationErrorCode': !(0, runtime_1.exists)(json, 'validation_error_code') ? undefined : (0, ValidationErrorCode_1.ValidationErrorCodeFromJSON)(json['validation_error_code']),
        'minimumSpendMicro': !(0, runtime_1.exists)(json, 'minimum_spend_micro') ? undefined : json['minimum_spend_micro'],
    };
}
exports.PromoCodeResponseBaseFromJSONTyped = PromoCodeResponseBaseFromJSONTyped;
function PromoCodeResponseBaseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'promo_code_id': value.promoCodeId,
        'is_valid': value.isValid,
        'promo_code_amount_micro': value.promoCodeAmountMicro,
        'validation_error_code': (0, ValidationErrorCode_1.ValidationErrorCodeToJSON)(value.validationErrorCode),
        'minimum_spend_micro': value.minimumSpendMicro,
    };
}
exports.PromoCodeResponseBaseToJSON = PromoCodeResponseBaseToJSON;
